/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S7_HeadingInputs */

const tr_iade_iptal_s7_heading = /** @type {(inputs: Iade_Iptal_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Abonelik Süresi ve Yenileme`)
};

const en_iade_iptal_s7_heading = /** @type {(inputs: Iade_Iptal_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Subscription Term and Renewal`)
};

const de_iade_iptal_s7_heading = /** @type {(inputs: Iade_Iptal_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Laufzeit und Verlängerung`)
};

const ru_iade_iptal_s7_heading = /** @type {(inputs: Iade_Iptal_S7_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Срок подписки и продление`)
};

/**
* | output |
* | --- |
* | "7. Subscription Term and Renewal" |
*
* @param {Iade_Iptal_S7_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s7_heading = /** @type {((inputs?: Iade_Iptal_S7_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S7_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s7_heading(inputs)
	if (locale === "de") return de_iade_iptal_s7_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s7_heading(inputs)
	return tr_iade_iptal_s7_heading(inputs)
});